module.exports = __webpack_public_path__ + "img/hr-puberty-decal-27.00653421.png";